import React from 'react';
import { useChatApi } from './use_chat_api.js';

const useChatAppGrants = () => {
    const [appGrants, setAppGrants] = React.useState({});
    const api = useChatApi();
    React.useEffect(() => {
        api.chat
            .get("me/app_grants")
            .then((grants) => grants.reduce((acc, grant) => ({ ...acc, [grant.app_name]: grant }), {}))
            .then(setAppGrants);
    }, []);
    return {
        canCreateChat: (appName) => appGrants[appName] && appGrants[appName].create_conversations,
    };
};

export { useChatAppGrants };
//# sourceMappingURL=use_chat_app_grants.js.map
